import { Action } from '@ngrx/store';

import { Configurations } from './configurations.model';

export const ADD_CONFIGURATION = 'Add Configurations';


export class AddConfiguration implements Action {
    readonly type = ADD_CONFIGURATION;

    constructor(public payload: Configurations ) {}
}


export type ConfigurationActions =
| AddConfiguration;
